import React, { useState, useRef, useEffect } from 'react';
import styles from './DataInput.module.css';

export const DataInput = ({ text, type = 'text', bg, img, value, onChange, onBlur, wasText, currencyActive, setCurrencyActive }) => {
	const inputId = `input-${text.replace(/\s/g, "-").toLowerCase()}`;

	const [padding, setPadding] = useState(14);
	const [focus, setFocus] = useState(false);
	const [textWidth, setTextWidth] = useState(0);

	const inputRef = useRef(null);

	useEffect(() => {
		if (value?.length > 0) {
			setPadding(36);
		} else if (!focus) {
			setPadding(14);
		}
	}, [value, focus]); 

	const handleFocus = () => {
		setFocus(true);
		setPadding(36);
	};

	const handleBlur = () => {
		setFocus(false);
		if (!value) setPadding(14);
		if (onBlur) onBlur(value);
	};

	const handleContainerClick = () => {
		inputRef.current?.focus();
	};
	useEffect(() => {
		if (inputRef.current) {
			const span = document.createElement('span');
			span.style.visibility = 'hidden';
			span.style.position = 'absolute';
			span.style.whiteSpace = 'pre';
			span.style.font = window.getComputedStyle(inputRef.current).font;
			span.innerText = value;
			document.body.appendChild(span);
			setTextWidth(span.offsetWidth);
			document.body.removeChild(span);
		}
	}, [value]);

	return (
		<div
			className={styles.main}
			style={{ paddingTop: padding, paddingBottom: 14, backgroundColor: bg }}
			onClick={!currencyActive ? handleContainerClick : undefined}
		>
			<div onClick={currencyActive !== undefined ? handleContainerClick : undefined}>
				<div className={styles.container}>
					<input
						autocomplete="off"
						ref={inputRef}
						type={'text'}
						inputMode={type}
						id={inputId}
						onFocus={handleFocus}
						onBlur={handleBlur}
						onChange={e => {
							const val = e.target.value;

							if (!/^\d*$/.test(val) && type === 'numeric') return;

							if (val.length <= 5 && type === 'numeric') {
								onChange(val);
							} else if (val.length <= 50 && type !== 'numeric') {
								onChange(val);
							}
						}}
						value={value}
						placeholder=" "
						style={value || focus || wasText ? { marginLeft: 42 } : {}}
					/>
					{
						currencyActive !== undefined && value.length > 0 &&
						<p style={{
							position: 'absolute',
							left: 75 + textWidth + 4,
							top: '49%',
							transform: 'translateY(-50%)',
							color: '#fff',
							}}>{currencyActive === 0 ? '₽' : '₸'}</p>
					}
				</div>
				<img
					style={value || focus || wasText ? { top: 23 } : {}}
					src={img}
					alt="inputImg"
				/>
			</div>
			
			{
				currencyActive !== undefined &&
				<div className={styles.currency} style={value || focus || wasText ? { top: 21 } : {}}>
					<div onClick={() => setCurrencyActive(0)} className={currencyActive === 0 && styles.currencyActiveRub}>
						RUB
					</div>
						<div onClick={() => setCurrencyActive(1)} className={currencyActive === 1 && styles.currencyActiveKzt}>
						KZT
					</div>
				</div>
			}
			<label
				htmlFor={inputId}
				style={value || focus || wasText ? { top: 13 } : {}}
			>
				{text}
			</label>
		</div>
	);
};
